export default __webpack_public_path__ + "static/landing-790af10c0602ba17a3d7e17a873c4e5e.png";